/**
 * guestStore - Thin hydration semaphore.
 * Previously tracked isGuestMode; now anonymous identity comes from Supabase session.
 * _hasHydrated is still needed by AuthGuard to avoid routing decisions before storage loads.
 */

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { logger } from '../../helpers/logger.helper';
import { platformStorage } from './platformStorage';

interface GuestState {
  /** True once the persisted state has been loaded from storage. */
  _hasHydrated: boolean;
}

export const useGuestStore = create<GuestState>()(
  persist(
    (): GuestState => ({
      _hasHydrated: true,
    }),
    {
      name: 'zporti_guest_mode',
      storage: createJSONStorage(() => platformStorage),
      partialize: () => ({}),
      onRehydrateStorage: () => {
        return (_state, error) => {
          if (error) {
            logger.error('Failed to hydrate guest store:', error);
          }
          queueMicrotask(() => {
            useGuestStore.setState({ _hasHydrated: true });
          });
        };
      },
    },
  ),
);
